import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import ScrollToTop from "./components/ScrollToTop";
import CookieBanner from "./components/CookieBanner";

import Home from "./pages/Home";
import DentistaCalafell from "./pages/DentistaCalafell";
import Implantes from "./pages/Implantes";
import Ortodoncia from "./pages/Ortodoncia";
import Urgencias from "./pages/Urgencias";
import Estetica from "./pages/Estetica";
import Odontopediatria from "./pages/Odontopediatria";
import Equipo from "./pages/Equipo";
import Opiniones from "./pages/Opiniones";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contacto from "./pages/Contacto";
import Cookies from "./pages/Cookies";
import Privacidad from "./pages/Privacidad";
import AvisoLegal from "./pages/AvisoLegal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dentista-calafell" element={<DentistaCalafell />} />
            <Route path="/implantes-dentales-calafell" element={<Implantes />} />
            <Route path="/ortodoncia-invisible-calafell" element={<Ortodoncia />} />
            <Route path="/urgencias-dentales-calafell" element={<Urgencias />} />
            <Route path="/estetica-dental" element={<Estetica />} />
            <Route path="/odontopediatria" element={<Odontopediatria />} />
            <Route path="/equipo" element={<Equipo />} />
            <Route path="/opiniones" element={<Opiniones />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <CookieBanner />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
